import React, { useRef } from "react";
import gsap from "gsap";
import { chipImg, frameImg, frameVideo } from "../utils";
import { useGSAP } from "@gsap/react";
import { animateScrollTrigger } from "../utils/Animation";

const Howitworks = () => {
  const videoRef = useRef();
  useGSAP(() => {
    gsap.from("#chip", {
      scrollTrigger: {
        trigger: "#chip",
        start: "20% bottom",
      },
      opacity: 0,
      scale: 2,
      duration: 2,
      ease: "power2.inOut",
    });
    animateScrollTrigger(".g_fadeIn", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power2.inOut",
    });
  });
  return (
    <section className=" sm:py-32 py-20 sm:px-10 px-5">
      <div className="screen-max-width">
        <div
          id="chip"
          className="flex justify-center items-center w-full my-20"
        >
          <img src={chipImg} alt="chip" width={180} height={180} />
        </div>
        <div className="flex flex-col items-center">
          <h2 className="hiw-title text-4xl md:text-7xl font-semibold text-center">
            A17 pro chip.
            <br />A monster win for Gaming.
          </h2>

          <p className="hiw-subtitle text-gray-600 font-semibold text-xl md:text-2xl py-10 text-center">
            It's Here. The biggest redesign in the history of Apple GPU's.{" "}
          </p>
        </div>
        <div className="mt-10 md:mt-20 mb-14">
          <div className="relative h-full flex items-center justify-center">
            <div className="overflow-hidden">
              <img
                src={frameImg}
                alt="frame"
                className="bg-transparent relative z-10"
              />
            </div>
            <div className="absolute w-[95%] h-[90%] rounded-[20px] sm:rounded-[56px] overflow-hidden">
              <video
                className="pointer-events-none"
                playsInline
                muted
                autoPlay
                preload="none"
                ref={videoRef}
              >
                <source src={frameVideo} type="video/mp4" />
              </video>
            </div>
          </div>
          <p className="text-gray-400 font-semibold text-center mt-3">
            Honkai : Star-Rail 
          </p>
        </div>
        <div className="flex md:flex-row flex-col justify-between items-start gap-24">
          <div className="flex flex-1 justify-center flex-col ">
            <p className="text-gray-600 text-xl font-normal md:font-semibold opacity-0 translate-y-[100px] g_fadeIn">
              A17 Pro chip is an entirely new class of iPhone chip that delivers
              our{" "}
              <span className="text-white">
                best Graphic performance by far,
              </span>
            </p>

          <p className="text-gray-600 opacity-0 translate-y-[100px] g_fadeIn text-xl font-normal mt-2 md:font-semibold">
            Mobile{" "}
            <span className="text-white">
              games will look and feel so immersive
            </span>
            with incredibly detailed environments and characters.
          </p>
          </div>

          <div className="flex flex-1 justify-center flex-col g_fadeIn opacity-0 translate-y-[100px]">
            <p className="text-gray-600 text-xl font-normal md:font-semibold">
              New
            </p>
            <p className="text-white text-3xl md:text-5xl font-normal md:font-semibold my-2">
              Pro-class GPU
            </p>
            <p className="text-gray-600 text-xl font-normal md:font-semibold">
              with 6 cores
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Howitworks;
